import { Icon } from '@app/components/core/icon/Icon'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { ReactNode } from 'react'
import {
  faArrowRight,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TextLink } from '@app/components/core/link/TextLink'

export type MegaMenuMobileItemProps = {
  to?: string
  onClick?: () => void
  icon: IconDefinition
  label: string
  description?: string
  backgroundColor?: string
  children?: ReactNode
}

export const MegaMenuMobileItem = ({
  to,
  onClick,
  icon,
  label,
  description,
  backgroundColor,
  children,
}: MegaMenuMobileItemProps) => {
  const content = (
    <>
      <Icon
        icon={icon}
        size="small"
        style={{
          backgroundColor,
        }}
      />
      <Column gap="0.5rem" style={{ flex: 1 }}>
        <Text.Medium style={{ fontWeight: '700' }}>
          {label} <FontAwesomeIcon icon={faArrowRight} />
        </Text.Medium>
        {description && (
          <Text.Medium color="var(--shades-blue-400)">
            {description}
          </Text.Medium>
        )}
      </Column>
    </>
  )

  const linkContent = (
    <TextLink
      to={to}
      containerStyle={{ textDecoration: 'none' }}
      textStyle={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'flex-start',
      }}
    >
      {content}
    </TextLink>
  )

  return (
    <Column
      gap="1.5rem"
      style={{
        flexGrow: 0,
        padding: '0.5rem',
        borderRadius: '1rem',
        background: 'var(--shades-white)',
      }}
    >
      {to ? (
        onClick ? (
          <div onClick={onClick} style={{ width: '100%' }}>
            {linkContent}
          </div>
        ) : (
          linkContent
        )
      ) : (
        <button
          onClick={onClick}
          style={{
            display: 'flex',
            gap: '1rem',
            alignItems: 'flex-start',
            border: 'none',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
            textAlign: 'left',
            width: '100%',
          }}
        >
          {content}
        </button>
      )}
      {children && (
        <Column gap="2rem" style={{ paddingLeft: '3rem' }}>
          {children}
        </Column>
      )}
    </Column>
  )
}
